import { render, staticRenderFns } from "./SleeveCard.vue?vue&type=template&id=71af6106&scoped=true&"
import script from "./SleeveCard.vue?vue&type=script&lang=js&"
export * from "./SleeveCard.vue?vue&type=script&lang=js&"
import style0 from "./SleeveCard.vue?vue&type=style&index=0&id=71af6106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af6106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VSimpleTable})
